import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CacheCountryService } from 'src/app/services/cacheCountries.service';
import { ApiServicesService } from '../../services/api-services.service';
import { ImagilityBaseResponse } from 'src/app/data/models/response.model';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'authentication';
import { BeneAddress, BeneficiaryDetails, acceptedFileTypes } from 'app-models';
import { DependentProfileDataService } from '../../services/dependent-profile-data.service';
import { CustomValidationService } from 'src/app/services/custom-validation.service';
import { ReferenceLibraryService } from 'src/app/services/referenceLibrary.service';
import { ReferenceLibrary } from 'src/app/data/models/referenceLibrary.model';
import * as copyAddressLists from 'src/app/data/constants/copy-address-types';
import * as errorUtils from "src/app/modules/utility/global-utils";
import { UploadDocumentService } from 'src/app/services/upload-document.service';

@Component({
  selector: 'app-bene-personal-details',
  templateUrl: './bene-personal-details.component.html',
  styleUrls: ['./bene-personal-details.component.scss']
})
export class BenePersonalDetailsComponent implements OnInit {

  listCopyFornAddress = [];
  listCountry = [];
  listStatesCurrent = [];
  listStatesPermanent = [];
  listStatesMailing = [];
  listStatesBirth = [];
  listStatesMarriage = [];
  listCopyMailAddress = [];
  listCopyPermAddress = [];
  listCountryMarriage = [];
  listCountryForeignAdd = [];
  currentItemDisplay = [];
  listStatesForeign = [];
  listForeignCountry = [];
  observableSubscription$ = new Subject();
  beneSelfDetailsForm: FormGroup;
  showForienAddressMandatory: boolean = false;
  onlyFormBuilder;
  dependentIdSubscription: Subscription;
  showExpiryValidation: boolean = false;
  submitted: boolean = false;
  familyId: any;
  formData: any;
  currentFamilyId: number;
  filteredStates: any[];
  addressFilteredStates: any[];
  fAddressFilteredStates: any[];
  filtercitizen: any[];
  currentDate: string;
  employeeId: string | number;
  fbEmpId: any;
  beneficiaryId: number;
  beneficiaryData: BeneficiaryDetails;
  personalDetails: any;
  primaryEmail: any;
  addressTypeList: ReferenceLibrary[];
  maritalTypeList: ReferenceLibrary[];
  phoneTypeList: ReferenceLibrary[];
  emailTypeList: ReferenceLibrary[];
  showCitizenShipAquiredInfo = false;
  @Input() detailsAbout: any;
  viewMode: boolean = false;
  showEditButton: boolean = true;
  editDetails: boolean = false;
  beneAddress: BeneAddress[] = [];
  fileUploadConfigurations = {
    inputMultipleFlag: true,
    fileType: acceptedFileTypes,
    isFileListRequired: true,
    categoryName: 'BENPASSDOC',
    entityId: 0,
    fileCategory: 'PASSCOPY',
    listUploadedFiles: [],
    useCase: 'beneficiary',
    useCaseId: 0,
    documentTypeRequired: true,
    docummentTypeCode: 'BENPASSDOC',
    useEntityId: false,
    isDeleteEnabled: sessionStorage.getItem('bene-profile-viewMode') == 'true' ? false : true,
    isUploadEnabled: sessionStorage.getItem('bene-profile-viewMode') == 'true' ? false : true,
    familyId: null
  };
  listGender: ReferenceLibrary[];
  constructor(
    private referenceLibraryService: ReferenceLibraryService,
    private apiService: ApiServicesService,
    private beneSelfFormBuilder: FormBuilder,
    private cacheCountryService: CacheCountryService,
    private customValidationService: CustomValidationService,
    private toastr: ToastrService,
    private uploadDocumentService: UploadDocumentService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private dependentProfileDataService: DependentProfileDataService
  ) {
    this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;
    if (this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
    } else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : (this.authenticationService.currentUserValue ? this.authenticationService.currentUserValue['beneficiaryId'] : sessionStorage.getItem('beneficiaryId'));
    }
    this.cacheCountryService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
      if (data.listCountries.length > 0) {
        this.listCountry = [{ countryCode: '', countryName: 'Select', labelWithCode: 'Select', phoneCode: '' }, ...data.listCountries];
      }
    });

    this.listCopyMailAddress = copyAddressLists.MAILING_LIST;
    this.listCopyFornAddress = copyAddressLists.FOREIGN_LIST;
    this.listCopyPermAddress = copyAddressLists.PERMANENT_LIST;

  }

  ngOnInit(): void {
    this.referenceLibraryService.requestDataFromMultipleSources().subscribe(response => {
      this.addressTypeList = <ReferenceLibrary[]>response[0].data;
      this.maritalTypeList = <ReferenceLibrary[]>response[1].data;
      this.phoneTypeList = <ReferenceLibrary[]>response[2].data;
      this.emailTypeList = <ReferenceLibrary[]>response[3].data;
      this.listGender = <ReferenceLibrary[]>response[4].data;
      this.setvalidatations();
      this.getBeneficiaryDetails();
    });

    if (this.beneficiaryId) {
      this.fileUploadConfigurations.entityId = this.beneficiaryId;
      this.fileUploadConfigurations.useCaseId = this.beneficiaryId;
      this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
      this.getUpolodedFiles();
    }
  }



  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  setvalidatations() {
    this.beneSelfDetailsForm = this.beneSelfFormBuilder.group({
      id: [],
      visaSponsor:[''],
      userName: [''],
      fName: ['', Validators.required],
      mName: [''],
      lName: ['', Validators.required],
      title: [''],
      aliasName: [''],
      gender: this.beneSelfFormBuilder.group({
        id: [null],
        name: [null],
      }),
      dob: [''],
      ssn: [''],
      emailContacts: this.beneSelfFormBuilder.array([
        this.beneSelfFormBuilder.group({
          email: ['', [Validators.required, Validators.email]],
          id: [''],
          type: this.beneSelfFormBuilder.group({
            code: ['PRIM'],
            id: [this.emailTypeList.find(x => x.code === 'PRIM') ? this.emailTypeList.find(x => x.code === 'PRIM').id : null]
          })
        })
      ]),

      address: this.beneSelfFormBuilder.array([
        this.beneSelfFormBuilder.group({
          addressLine1: [''],
          addressLine2: [''],
          postCode: [''],
          doorNo: [''],
          id: [''],
          streetNo: [''],
          countryCode: this.beneSelfFormBuilder.group({
            countryCode: ['']
          }),
          stateProvinceCode: [null],
          stateProvinceName: [''],
          city: [''],
          locality: [''],
          type: this.beneSelfFormBuilder.group({
            id: [this.addressTypeList.find(x => x.code === 'CURR') ? this.addressTypeList.find(x => x.code === 'CURR').id : null],
            code: ['CURR']
          })
        }),
        this.beneSelfFormBuilder.group({
          addressLine1: [''],
          addressLine2: [''],
          postCode: ['', [Validators.pattern(/^[a-zA-Z0-9 ]+$/)]],
          doorNo: [''],
          id: [''],
          streetNo: [''],
          countryCode: this.beneSelfFormBuilder.group({
            countryCode: ['']
          }),
          stateProvinceCode: [null],
          stateProvinceName: [''],
          city: [''],
          locality: [''],
          type: this.beneSelfFormBuilder.group({
            id: [this.addressTypeList.find(x => x.code === 'FORN') ? this.addressTypeList.find(x => x.code === 'FORN').id : null],
            code: ['FORN']
          })
        })
      ]),
      countryCode: this.beneSelfFormBuilder.group({
        countryCode: ['']
      }),
      birthStateProvinceCode: [null],
      birthStateProvinceName: [''],
      birthCity: [''],
      ctznshipCountryCode: this.beneSelfFormBuilder.group({
        countryName: null,
        countryCode: ['']
      }),
      passport: this.beneSelfFormBuilder.array([
        this.beneSelfFormBuilder.group({
          id: [''],
          passportNo: [''],
          issueDate: [''],
          expiryDate: [''],
          issueCountryCode: this.beneSelfFormBuilder.group({
            countryCode: ['']
          })
        })
      ])
    });

    if (this.onlyFormBuilder === 'FB') {
      this.beneSelfDetailsForm.get('isLpr').clearValidators();
      this.beneSelfDetailsForm.get('isLpr').updateValueAndValidity();
    }
  }
  resetBirthStateOnCountryChange() {
    this.beneSelfDetailsForm.get('birthStateProvinceCode').clearValidators();
    this.beneSelfDetailsForm.get('birthStateProvinceName').clearValidators();
    this.beneSelfDetailsForm.get('birthStateProvinceCode').setValue(null);
    this.beneSelfDetailsForm.get('birthStateProvinceName').setValue(null);
    this.beneSelfDetailsForm.get('birthStateProvinceCode').updateValueAndValidity();
    this.beneSelfDetailsForm.get('birthStateProvinceName').updateValueAndValidity();
  }
  handleCountryChange(countryCode: string, stateIndex) {
    // IM-3402 - Added to update state blank for US and India
    if (stateIndex === 'Current') {
      this.listStatesCurrent = [];
    } else if (stateIndex === 'Permanent') {
      this.listStatesPermanent = [];
    } else if (stateIndex === 'Mailing') {
      this.listStatesMailing = [];
    }

    this.apiService.getStates(countryCode).pipe(takeUntil(this.observableSubscription$)).subscribe((states: []) => {
      switch (stateIndex) {
        case 'Current':
          this.listStatesCurrent = states;
          // this.applyStateValidation(states, 0);
          // this.applyForeignAddressValidation(countryCode, states, 2); //IM-3402 fix
          break;
        case 'Permanent':
          this.listStatesPermanent = states;
          //this.applyStateValidation(states, 1);
          break;
        case 'Foreign':
          this.listStatesForeign = states;
          //this.applyForeignStateValidation(states, 2); //IM-3402 fix
          break;
        case 'Birth':
          this.listStatesBirth = states;
          //this.applyBirthStateValidation(states, countryCode);
          break;
        case 'Marriage':
          this.listStatesMarriage = states;
          //  this.applyBirthStateValidation(states);
          break;
        case 'Mailing':
          this.listStatesMailing = states;
          break;

      }
    });
  }

  getStateName(stateProvinceCodes, stateIndex) {
    switch (stateIndex) {
      case 'Current':
        const selectedCurrStateObj = this.listStatesCurrent.find(x => x.stateProvinceCode === stateProvinceCodes);
        return (selectedCurrStateObj) ? selectedCurrStateObj.stateProvinceName : '--';
      case 'Permanent':
        const selectedPermStateObj = this.listStatesPermanent.find(x => x.stateProvinceCode === stateProvinceCodes);
        return (selectedPermStateObj) ? selectedPermStateObj.stateProvinceName : '--';
      case 'Permanent':
        const selectedMailStateObj = this.listStatesMailing.find(x => x.stateProvinceCode === stateProvinceCodes);
        return (selectedPermStateObj) ? selectedPermStateObj.stateProvinceName : '--';
      case 'Foreign':
        const selectedFornStateObj = this.listStatesForeign.find(x => x.stateProvinceCode === stateProvinceCodes);
        return (selectedFornStateObj) ? selectedFornStateObj.stateProvinceName : '--';
      case 'Birth':
        const selectedBirthStateObj = this.listStatesBirth.find(x => x.stateProvinceCode === stateProvinceCodes);
        return (selectedBirthStateObj) ? selectedBirthStateObj.stateProvinceName : '--';
      case 'Marriage':
        const selectedMarriageStateObj = this.listStatesMarriage.find(x => x.stateProvinceCode === stateProvinceCodes);
        return (selectedMarriageStateObj) ? selectedMarriageStateObj.stateProvinceName : '--';
      case 'Mailing':
        const selectedMailingStateObj = this.listStatesMailing.find(x => x.stateProvinceCode === stateProvinceCodes);
        return (selectedMailingStateObj) ? selectedMailingStateObj.stateProvinceName : '--';
    }
  }

  handleStateChange(statecode, stateIndex) {
    this.beneSelfDetailsForm.get('address')['controls'][stateIndex].get('stateProvinceCode').clearValidators();
    if (statecode === "null") {
      this.beneSelfDetailsForm.get('address')['controls'][stateIndex].get('stateProvinceCode').setValidators(null);
      this.beneSelfDetailsForm.get('address')['controls'][stateIndex].get('stateProvinceCode').value = null;
      this.beneSelfDetailsForm.get('address')['controls'][stateIndex].get('stateProvinceName').value = '';
      this.beneSelfDetailsForm.updateValueAndValidity();
    }
    else {

      this.beneSelfDetailsForm.get("address")['controls'][stateIndex].patchValue({
        stateProvinceName: this.getStateName(statecode, stateIndex == 0 ? 'Current' : 'Foreign')

      });
    }
  }

  resetStateOnCountryChange(index: number) {
    this.beneSelfDetailsForm.get('address')['controls'][index].get('stateProvinceCode').value = null;
    this.beneSelfDetailsForm.get('address')['controls'][index].get('stateProvinceName').value = '';
  }

  copyAddress(copyFrom, copyTo) {
    if (copyFrom && copyTo) {
      const addressValue = this.getAddress(copyFrom);
      this.patch(addressValue.value, copyTo, copyTo);
    } else {
      this.resetAddress(copyTo);
    }
  }

  getAddress(code): FormGroup {
    let Address: any;
    for (const control of (this.beneSelfDetailsForm.get('address') as FormArray).controls) {
      if (control.value.type.code === code) {
        Address = control;
        return Address;
      }
    }
  }

  resetAddress(addressType: string) {
    let addressTypeCode = '';
    switch (addressType.toLowerCase()) {
      case 'permanent':
        this.listStatesPermanent = [];
        addressTypeCode = 'PERM';
        break;
      case 'foreign':
        this.listStatesForeign = [];
        addressTypeCode = 'FORN';
        break;
      case 'mailing':
        this.listStatesMailing = [];
        addressTypeCode = 'MAIL';
        break;
    }
    const resetAddress = this.getAddress(addressTypeCode);
    if (resetAddress) {
      const resetAddressType = resetAddress.value.type;
      const resetAddressID = resetAddress.value.id;
      resetAddress.reset();
      resetAddress.patchValue(
        {
          id: resetAddressID,
          type: resetAddressType
        }
      );
    }
  }

  patch(group, stateIndex, addType) {
    if (group.countryCode.countryCode) {
      this.handleCountryChange(group.countryCode.countryCode, stateIndex);
    }
    if (addType === 'Foreign') {
      const foreignAddress = this.getAddress('FORN');
      const foreignAddressType = foreignAddress.value.type;
      const foreignAddressID = foreignAddress.value.id;
      foreignAddress.setValue(group);
      foreignAddress.patchValue(
        {
          id: foreignAddressID,
          type: foreignAddressType
        }
      );

    } else if (addType === 'Mailing') {
      const mailAddress = this.getAddress('MAIL');
      const mailAddressType = mailAddress.value.type;
      const mailAddressID = mailAddress.value.id;
      mailAddress.setValue(group);
      mailAddress.patchValue(
        {
          id: mailAddressID,
          type: mailAddressType
        }
      );
    } else if (addType === 'Permanent') {
      const permAddress = this.getAddress('PERM');
      const permAddressType = permAddress.value.type;
      const permAddressID = permAddress.value.id;
      permAddress.setValue(group);
      permAddress.patchValue(
        {
          id: permAddressID,
          type: permAddressType
        }
      );
    }
  }

  getAddressGroup(addrType) {
    let temp = this.beneSelfDetailsForm.get('address');
    if (temp instanceof FormArray) {
      return temp.controls.findIndex(x => x.value['type']['code'] === addrType);
    }
  }

  validateExpiry(issueDate, expiryDate) {
    this.showExpiryValidation = this.customValidationService.MaxDateValidate(issueDate, expiryDate);
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.beneSelfDetailsForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    // console.log(invalid);
    return invalid;
  }

  updateCountry(countryCode, field) {
    if (field === 'ctznshipCountryCode') {
      this.beneSelfDetailsForm.get("ctznshipCountryCode").patchValue({
        countryCode: countryCode,
        countryName: this.listCountry.find(x => x.countryCode === countryCode).countryName
      });
      this.updateCountry(countryCode, 'issueCountryCode');
    } else {
      if (this.onlyFormBuilder !== 'FB') {
        this.beneSelfDetailsForm.get("passport")['controls'][0].get('issueCountryCode').patchValue({
          countryCode: countryCode,
          countryName: this.listCountry.find(x => x.countryCode === countryCode).countryName

        });
      }
    }
  }


  savePersonalData(isDraft: boolean = false) {
    if (!isDraft) {
      this.submitted = true;
      if (this.beneSelfDetailsForm.invalid) {
        this.findInvalidControls();
        return;
      }
    }
    this.beneSelfDetailsForm.patchValue({
      dob: this.beneSelfDetailsForm.get('dob').value ? moment(this.beneSelfDetailsForm.get('dob').value).format('YYYY-MM-DD') : null,
      birthStateProvinceName: this.listStatesBirth.length <= 0 ? this.beneSelfDetailsForm.get('birthStateProvinceName').value : this.getStateName(this.beneSelfDetailsForm.get('birthStateProvinceCode').value, 'Birth') ? this.getStateName(this.beneSelfDetailsForm.get('birthStateProvinceCode').value, 'Birth') : null
    });
    const passportExpiryDate = this.beneSelfDetailsForm.get("passport")['controls'][0].get('expiryDate').value;
    const passportIssueDate = this.beneSelfDetailsForm.get("passport")['controls'][0].get('issueDate').value;
    this.beneSelfDetailsForm.get("passport")['controls'][0].patchValue({
      expiryDate: passportExpiryDate ? moment(passportExpiryDate).format('YYYY-MM-DD') : '',
      issueDate: passportIssueDate ? moment(passportIssueDate).format('YYYY-MM-DD') : '',
    });
    const foreignAddressIndex = this.beneSelfDetailsForm.value.address.findIndex(x => x.type.code === 'FORN');
    const foreignAddressValue = (this.beneSelfDetailsForm.get('address') as FormArray)
      .controls[foreignAddressIndex]?.value;

    if (foreignAddressValue) {
      if (!this.showForienAddressMandatory && (!foreignAddressValue.addressLine1 || (foreignAddressValue.addressLine1 && foreignAddressValue.addressLine1.trim() === '')) &&
        (!foreignAddressValue.addressLine2 || (foreignAddressValue.addressLine2 && foreignAddressValue.addressLine2.trim() === '')) &&
        (!foreignAddressValue.locality || (foreignAddressValue.locality && foreignAddressValue.locality.trim() === '')) &&
        (!foreignAddressValue.countryCode || (foreignAddressValue.countryCode && (!foreignAddressValue.countryCode.countryCode || (foreignAddressValue.countryCode.countryCode && foreignAddressValue.countryCode.countryCode.trim() === '')))) &&
        ((this.listStatesForeign.length <= 0 &&
          (!foreignAddressValue.stateProvinceName ||
            (foreignAddressValue.stateProvinceName && foreignAddressValue.stateProvinceName.trim() === ''))) ||
          (this.listStatesForeign.length > 0 && (!foreignAddressValue.stateProvinceCode ||
            (foreignAddressValue.stateProvinceCode && foreignAddressValue.stateProvinceCode.trim() === '')))) &&
        (!foreignAddressValue.city || (foreignAddressValue.city && foreignAddressValue.city.trim() === '')) &&
        (!foreignAddressValue.postCode || (foreignAddressValue.postCode && foreignAddressValue.postCode.trim() === ''))) {
        this.beneSelfDetailsForm.value.address.splice(foreignAddressIndex);
      }
    }
    //delete empty address type
    this.beneSelfDetailsForm.value['address']?.forEach((el, index) => {
      if (!el?.type?.code) {
        this.beneSelfDetailsForm.value['address'].splice(index, 1);
      } else if (el?.countryCode?.countryCode === '') {
        el.countryCode.countryCode = null;
      }
    })

    let alias = null;
    if (this.beneSelfDetailsForm.value['aliasName'] != null) {
      alias = [{
        fName: this.beneSelfDetailsForm.value['aliasName'],
        title: '',
        id: ''
      }]
    } else {
      alias = null
    }
    const payload = {
      ... this.beneSelfDetailsForm.value,
      isSaveAsDraft: false,
      aliasName: alias,
      birthCountryCode: this.beneSelfDetailsForm.value['countryCode']['countryCode'] ? this.beneSelfDetailsForm.value['countryCode'] : null,
      hasPassport: !this.beneSelfDetailsForm.value['hasPassport'],
      ctznshipCountryCode: !this.beneSelfDetailsForm.value['ctznshipCountryCode']['countryCode'] ? { countryCode: null, countryName: null } : this.beneSelfDetailsForm.value['ctznshipCountryCode'],
      countryCode: this.beneSelfDetailsForm.value['countryCode']['countryCode'] ? this.beneSelfDetailsForm.value['countryCode'] : null,
      gender: this.beneSelfDetailsForm.value['gender'] ? {
        id: this.beneSelfDetailsForm.value['gender']['id'],
        name: this.beneSelfDetailsForm.value['gender']['name']
      } : {
        id: null,
        name: null
      }
    };
    payload.id = this.beneficiaryId;
    let url = this.apiService.saveSimpleBeneficiaryDetails(this.beneficiaryId, 'self', payload);

    url.pipe(takeUntil(this.observableSubscription$)).subscribe((data: ImagilityBaseResponse) => {
      if (data.status === 200) {
        if (this.onlyFormBuilder === 'FB') {
          this.beneficiaryId = data.data.beneficiaryId;
          sessionStorage.setItem('FbEmployeeId', this.beneficiaryId.toString());
        }
        this.showEditButton = true;
        this.editDetails = false;
        this.beneSelfDetailsForm.reset(this.beneSelfDetailsForm.value);
        this.toastr.success(data.message, 'Success');
        this.getBeneficiaryDetails();
      }
    });

  }

  getBeneficiaryDetails() {
    let orderedArr: BeneAddress[] = [];
    this.apiService.getBeneficiaryDetails(this.beneficiaryId, 'self')
      .pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiary: BeneficiaryDetails) => {
        this.beneficiaryData = beneficiary;
        this.beneSelfDetailsForm.patchValue({
          dob: beneficiary.dob && moment(beneficiary.dob, 'YYYY-MM-DD').toDate(),
          passport: beneficiary.passport?.length ? [{
            ...beneficiary.passport[0],
            expiryDate: beneficiary.passport[0].expiryDate && moment(beneficiary.passport[0].expiryDate, 'YYYY-MM-DD').toDate(),
            issueDate: beneficiary.passport[0].issueDate && moment(beneficiary.passport[0].issueDate, 'YYYY-MM-DD').toDate()
          }] : beneficiary.passport,
          fName: beneficiary.fName,
          mName: beneficiary.mName,
          lName: beneficiary.lName,
          ssn: beneficiary.ssn,
          birthStateProvinceCode: beneficiary.birthStateProvinceCode,
          birthStateProvinceName: beneficiary.birthStateProvinceName,
          countryCode: beneficiary?.countryCode ? beneficiary?.countryCode : {
            countryCode: null,
            countryName: null
          },
          ctznshipCountryCode: beneficiary?.ctznshipCountryCode ? beneficiary?.ctznshipCountryCode : {
            countryCode: null,
            countryName: null
          },
          emailContacts: beneficiary.emailContacts,
          gender: beneficiary?.gender ? { id: beneficiary.gender?.id, name: beneficiary.gender?.name } : { id: null, name: null }
        });

        let showAliasName;
        if (beneficiary && beneficiary.aliasName.length > 0) {
          showAliasName = beneficiary.aliasName[0].fName;
        }
        this.beneSelfDetailsForm.patchValue({ aliasName: showAliasName })
        let pEmail = [];
        beneficiary.emailContacts.forEach(email => {
          if (email.type?.code === "PRIM") {
            pEmail.push(email);
            this.primaryEmail = email;
          }
        });
        this.beneSelfDetailsForm.patchValue({ emailContacts: pEmail })


        if (beneficiary.address && beneficiary.address.length > 0) {
          if (beneficiary.address.find(x => x.type.code === 'CURR')) {
            orderedArr[0] = beneficiary.address.find(x => x.type.code === 'CURR');
          }
          if (beneficiary.address.find(x => x.type.code === 'FORN')) {
            orderedArr[1] = beneficiary.address.find(x => x.type.code === 'FORN');
          } else {
            orderedArr[1] = this.emptyAddress('Foreign');
          }
        } else {
          orderedArr.push(this.emptyAddress('Current'), this.emptyAddress('Foreign'), this.emptyAddress('Mailing'), this.emptyAddress('Permanent'));
        }


        if (beneficiary.address && beneficiary.address.length > 0) {
          if (beneficiary.address[0] && beneficiary.address[0].countryCode && beneficiary.address[0].countryCode.countryCode) {
            this.handleCountryChange(beneficiary.address[0].countryCode.countryCode, 'Current');
          } else if (beneficiary.address[0] && !beneficiary.address[0].countryCode) {
            beneficiary.address[0]['countryCode'] = {
              countryCode: '',
              countryName: ''
            };
          }
          if (beneficiary.address[1] && beneficiary.address[1].countryCode && beneficiary.address[1].countryCode.countryCode) {
            this.handleCountryChange(beneficiary.address[1].countryCode.countryCode, 'Foreign');
          }
          if (beneficiary.address[1] && !beneficiary.address[1].countryCode) {
            //IM-3932-For Existing beneficiary-after clicking on edit link-country code, mobile no, email id, passport fields are showing blank
            beneficiary.address[1]['countryCode'] = {
              countryCode: '',
              countryName: ''
            };
          }
        }

        this.beneSelfDetailsForm.patchValue({ address: orderedArr })
        this.beneAddress = orderedArr;
        if(beneficiary?.countryCode?.countryCode){
          this.handleCountryChange(beneficiary.countryCode.countryCode, 'Birth');
        }
      });
  }

  getUpolodedFiles() {
    this.fileUploadConfigurations.familyId = this.familyId ? this.familyId : null;
    this.currentFamilyId = this.fileUploadConfigurations.familyId;
    this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
    //this.editClicked =  (sessionStorage.getItem('dependentId') == '0') ? false : true
    this.uploadDocumentService.genericGetUploadDocument(this.fileUploadConfigurations.useCase, this.fileUploadConfigurations.useCaseId, this.fileUploadConfigurations.categoryName, this.fileUploadConfigurations.entityId, this.fileUploadConfigurations.useEntityId, this.fileUploadConfigurations.familyId).subscribe((response) => {
      if (response['status'] === 200) {
        this.fileUploadConfigurations.listUploadedFiles = response['data'];
        this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
      }
      else {
        this.fileUploadConfigurations.listUploadedFiles = [];
        this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
      }
    });
  }

  emptyAddress(addressType: string) {
    const addressObj = {
      id: null,
      addressLine1: '',
      addressLine2: null,
      countryCode: {
        countryCode: null,
        countryName: null,
      },
      stateProvinceCode: null,
      stateProvinceName: null,
      state: null,
      city: '',
      locality: null,
      postCode: null,
      inCareOfName: null,
      county: null,
      dateRangeFrom: null,
      type: { id: null, code: null, name: null }
    };
    switch (addressType) {
      case 'Current':
        addressObj.type = {
          id: this.addressTypeList.find(x => x.code === 'CURR') ? this.addressTypeList.find(x => x.code === 'CURR').id : null,
          code: 'CURR',
          name: 'Current'
        };
        break;
      case 'Permanent':
        addressObj.type = {
          id: this.addressTypeList.find(x => x.code === 'PERM') ? this.addressTypeList.find(x => x.code === 'PERM').id : null,
          code: 'PERM',
          name: 'Permanent'
        };
        break;
      case 'Foreign':
        addressObj.type = {
          id: this.addressTypeList.find(x => x.code === 'FORN') ? this.addressTypeList.find(x => x.code === 'FORN').id : null,
          code: 'FORN',
          name: 'Foreign'
        };
        break;
      case 'Mailing':
        addressObj.type = {
          id: this.addressTypeList.find(x => x.code === 'MAIL') ? this.addressTypeList.find(x => x.code === 'MAIL').id : null,
          code: 'MAIL',
          name: 'Mailing'
        };
        break;
    }
    return addressObj;
  }

  clearForm() {
    this.beneSelfDetailsForm.reset();
  }

  ngOnDestroy() {
    this.beneSelfDetailsForm.reset();
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

  handleEdit() {
    this.editDetails = !this.editDetails;
    this.beneSelfDetailsForm.enable();
  }

  onGenderChange(event: any) {
    const genderObject = this.listGender.find((g)=> g.id === event.value);
    this.beneSelfDetailsForm.patchValue({gender: {id: event.value, name: genderObject?.name }});
  }

}
